// Intercept all ajax requests to add Akamai-BM-Telemetry header
exports.onClientEntry = (_, { whitelist = [] }) => {
  // Check if a given URL matches the whitelist
  whitelist = whitelist.map(url => url.toLowerCase());
  const isWhitelisted = requestUrl => (
    !whitelist.length || whitelist.some(url => requestUrl.split('?')[0].toLowerCase().includes(url))
  );

  // Intercept window.fetch
  const _fetch = window.fetch;
  window.fetch = function(resource, options) {
    try {
      const url = resource?.url || resource || '';
      const headers = new Headers(resource?.headers || options?.headers || {});
      if (isWhitelisted(url)) {
        headers.append('Akamai-BM-Telemetry', window.bmak.get_telemetry());
        if (resource?.url) resource.headers = headers;
        if (options) options.headers = headers;
      }
    } catch(e) {
      if (!window.bmak) console.info(`gatsby-plugin-akamai-bot-manager: Akamai telemetry not loaded.`);
      else console.warn(`gatsby-plugin-akamai-bot-manager: Could not append header. ${e}`);
    }

    return _fetch.apply(this, [resource, options].filter(Boolean));
  };

  // Intercept XMLHttpRequest.open
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(...args) {
    const result = _open.apply(this, args);
    try {
      const url = typeof args[1] == 'string' ? args[1] : '';
      if (isWhitelisted(url)) this.setRequestHeader('Akamai-BM-Telemetry', window.bmak.get_telemetry());
    } catch(e) {
      if (!window.bmak) console.info(`gatsby-plugin-akamai-bot-manager: Akamai telemetry not loaded.`);
      else console.warn(`gatsby-plugin-akamai-bot-manager: Could not append header. ${e}`);
    }
    return result;
  };

  // Intercept axios
  if (window.axios) {
    window.axios?.interceptors?.request?.use?.(
      config => {
        try {
          if (isWhitelisted(config.url)) config.headers['Akamai-BM-Telemetry'] = window.bmak.get_telemetry();
        } catch(e) {
          if (!window.bmak) console.info(`gatsby-plugin-akamai-bot-manager: Akamai telemetry not loaded.`);
          else console.warn(`gatsby-plugin-akamai-bot-manager: Could not append header. ${e}`);
        }
        return config;
      },
      error => Promise.reject(error)
    );
  }
};
